import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';
import { Gps } from './../../shared/gps';

@Component({
  selector: 'app-mapclick',
  templateUrl: './mapclick.component.html',
  styleUrls: ['./mapclick.component.css']
})
export class MapclickComponent extends BaseComponent implements OnInit {
  @ViewChild('map', { static: true }) mapElement: any = {};
  gps = new Gps();
  map: any = {};
  showTip = false;
  counter = 1;

  constructor(injector: Injector) { super(injector) }

  ngOnInit(): void {
  }

  async getLocation() {
    let { ok, data }: any = await this.gps.getLocation();
    if (!ok) return this.error("Cannot get GPS location: ", data);

    this.showPosition(data);
    this.showTip = true;

  }

  showPosition(coord: any) { 
    const svgMarker = {
      path: "M10.453 14.016l6.563-6.609-1.406-1.406-5.156 5.203-2.063-2.109-1.406 1.406zM12 2.016q2.906 0 4.945 2.039t2.039 4.945q0 1.453-0.727 3.328t-1.758 3.516-2.039 3.070-1.711 2.273l-0.75 0.797q-0.281-0.328-0.75-0.867t-1.688-2.156-2.133-3.141-1.664-3.445-0.75-3.375q0-2.906 2.039-4.945t4.945-2.039z",
      fillColor: "blue",
      fillOpacity: 0.6,
      strokeWeight: 0,
      rotation: 0,
      scale: 2,
      anchor: new google.maps.Point(15, 30),
    };
    
    const mapProperties = {
      center: new google.maps.LatLng(coord),
      zoom: 15,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };

    this.map = new google.maps.Map(this.mapElement.nativeElement, mapProperties);

    new google.maps.Marker({
      position: coord,
      map: this.map,
      title: "My Location",
    });

    this.map.addListener("click", (mapsMouseEvent: any) => {
      this.alert.success(JSON.stringify(mapsMouseEvent.latLng.toJSON()));
      new google.maps.Marker({
        position: mapsMouseEvent.latLng,
        map: this.map,
        icon: svgMarker,
        title: "Location "+ this.counter,        
      });
      this.counter+=1;
    });

    const cityCircle = new google.maps.Circle({
      strokeColor: "#FF0000",
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: "#FF0000",
      fillOpacity: 0.35,
      map: this.map,
      center: coord,
      radius: 70,
    });
  }



}
